import React from "react";

const CmykMark = ({ size = 100 }) => {
  const center = size / 2;
  const radius = center - size * 0.1; // Pull the circle inward
  const smallCircleRadius = size * 0.05; // Small circle near the center
  const crossStrokeWidth = size * 0.02; // Width of the cross lines
  const crossExtension = size * 0.1; // Extend crosshairs beyond the circle

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Black quadrant */}
      <path
        d={`M ${center} ${center} 
            L ${center} ${size - crossExtension} 
            A ${radius} ${radius} 0 0 0 ${size - crossExtension} ${center} 
            Z`}
        fill="#000000"
      />
      {/* Cyan quadrant */}
      <path
        d={`M ${center} ${center} 
            L ${center} ${crossExtension} 
            A ${radius} ${radius} 0 0 0 ${crossExtension} ${center} 
            Z`}
        fill="#00FFFF"
      />
      {/* Magenta quadrant */}
      <path
        d={`M ${center} ${center} 
            L ${size - crossExtension} ${center} 
            A ${radius} ${radius} 0 0 0 ${center} ${crossExtension} 
            Z`}
        fill="#FF00FF"
      />
      {/* Yellow quadrant */}
      <path
        d={`M ${center} ${center} 
            L ${crossExtension} ${center} 
            A ${radius} ${radius} 0 0 0 ${center} ${size - crossExtension} 
            Z`}
        fill="#FFFF00"
      />
      {/* Crosshairs */}
      <line
        x1={center}
        y1="0"
        x2={center}
        y2={size}
        stroke="black"
        strokeWidth={crossStrokeWidth}
      />
      <line
        x1="0"
        y1={center}
        x2={size}
        y2={center}
        stroke="black"
        strokeWidth={crossStrokeWidth}
      />
      {/* Small Center Circle (No Fill) */}
      <circle
        cx={center}
        cy={center}
        r={smallCircleRadius}
        stroke="black"
        strokeWidth={crossStrokeWidth / 2}
        fill="none"
      />
    </svg>
  );
};

export default CmykMark;
